'use client';

import { c as _c } from "react/compiler-runtime";
import { X, Check } from 'lucide-react';
import Link from 'next/link';
const withoutItems = ['No idea where to start or what to try', 'Cold outreach to venues, retailers, and buyers', 'Weeks of planning before anything goes live', 'Hard to try new things when everything is manual', "Miss out on expos, pitch events, and meetups you didn't know about"];
const withItems = ['Ready-made initiative ideas for consumers and buyers', 'Pre-qualified venues, retailers, and partners already on the platform', 'Launch promotions, sampling, offers, and activations in days', 'Discover expos, pitch events, and brand-buyer meetups', 'One place to plan, set up, and execute — try more with less effort'];
export function DifferentiationSection() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center mb-14"><h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">No more excuses.</h2><h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">Start doing and getting results.</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-6">Without Sizzle</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="rounded-2xl border border-gray-200 bg-white p-8">{t1}<ul className="space-y-4">{withoutItems.map(_temp)}</ul></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute -top-3 left-6 px-3 py-0.5 bg-primary-600 text-white text-xs font-bold rounded-full">Better way</div>;
    t4 = <div className="text-sm font-bold text-primary-600 uppercase tracking-widest mb-6">With Sizzle</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-3xl mx-auto">{t2}<div className="rounded-2xl border-2 border-primary-200 bg-primary-50/30 p-8 relative">{t3}{t4}<ul className="space-y-4">{withItems.map(_temp2)}</ul></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="py-20 lg:py-28"><div className="container mx-auto px-4 sm:px-6 lg:px-8">{t0}{t5}<div className="text-center mt-12"><Link href="/opportunities" className="inline-flex items-center gap-2 text-primary-600 font-semibold hover:underline cursor-pointer text-2xl">Browse opportunities →</Link></div></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp2(item_0) {
  return <li key={item_0} className="flex items-start gap-3 text-gray-800"><Check className="h-5 w-5 text-primary-600 flex-shrink-0 mt-0.5" />{item_0}</li>;
}
function _temp(item) {
  return <li key={item} className="flex items-start gap-3 text-gray-500"><X className="h-5 w-5 text-gray-300 flex-shrink-0 mt-0.5" />{item}</li>;
}